import { render, staticRenderFns } from "./QualificationRecords.vue?vue&type=template&id=6fefc420"
import script from "./QualificationRecords.vue?vue&type=script&lang=js"
export * from "./QualificationRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports